export default "__VITE_ASSET__BehU0jII__"